<!-- eslint-disable max-len -->
<template>
  <div>
    <div
      id="background"
      style="width: 100%; text-align:center; padding: 14px 0 5px;background-image: -webkit-gradient(linear, right top, left top, from(#0399cc), to(#0c3764));background-image: -o-linear-gradient(right, #0399cc, #0c3764);background-image: linear-gradient(to left, #0399cc, #0c3764);-webkit-print-color-adjust: exact;"
    >
      <img
        src="@/assets/logo-small.png"
        style="max-height: 50px"
      >
    </div>
    <view-title>
      <v-icon class="primary--text mr-4">fas fa-chart-bar</v-icon> {{ report }}
      <template slot="button">
        <v-col class="text-right">
          <report-download-selection
            :download="download"
            :csv-data="csvData"
            :report="report"
          />
        </v-col>
      </template>
    </view-title>
  </div>
</template>
<script>
import viewTitle from '@/components/view-title.vue';
import reportDownloadSelection from '@/components/report-download-selection.vue';

export default {
  components: {
    viewTitle,
    reportDownloadSelection,
  },
  props: {
    download: {
      type: Function,
      default: () => {},
    },
    report: {
      type: String,
      default: '',
    },
    csvData: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
